import { render, staticRenderFns } from "./MyPaperList.vue?vue&type=template&id=30d36af9&scoped=true&"
import script from "@/scripts/Events/components/MyPaperList?vue&type=script&lang=js&"
export * from "@/scripts/Events/components/MyPaperList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d36af9",
  null
  
)

export default component.exports